<template>
  <div class="shirt_config">
    <div class="shirt_measurements">
      <h4 class="shirt_measurements_header">Shirt Measurements</h4>
      <div
        :style="{
          'background-image': `url(${require('../../assets/shirt.gif')})`
        }"
        class="measures-container"
      >
        <!-- shirt_m_02 -->
        <garment-config
          :smart="smartMeasures.chest"
          :smart-measurements="smartMeasurements.chest"
          :init-garment="initGarmentMeasures.chest"
          label="1/2 POITRINE"
          class="demi-poitrine"
          name="demi_poitrine"
          @config="set"
        />
        <!-- shirt_m_03 -->
        <garment-config
          :smart="smartMeasures.waist"
          :smart-measurements="smartMeasurements.waist"
          :init-garment="initGarmentMeasures.waist"
          label="1/2 TAILLE"
          class="demi-taille"
          name="demi_taille"
          @config="set"
        />
        <!-- shirt_m_04 -->
        <garment-config
          :smart="smartMeasures.hips"
          :smart-measurements="smartMeasurements.hips"
          :init-garment="initGarmentMeasures.hips"
          label="1/2 BASSIN"
          class="demi-bassin"
          name="demi_bassin"
          @config="set"
        />
        <!-- shirt_m_08 shirt_m_09 -->
        <garment-config-2
          :smart="smartMeasures.cuff"
          :smart-measurements="smartMeasurements.cuff"
          :init-garment-left="initGarmentMeasures.wristl"
          :init-garment-right="initGarmentMeasures.wristr"
          label="1/2 POIGNETS BOUTONNES"
          class="demi-poignets-boutonnes"
          name="wrist"
          @config="set"
        />
        <!-- shirt_m_06 shirt_m_07 -->
        <garment-config-2
          :smart="smartMeasures.sleeve_length"
          :smart-measurements="smartMeasurements.sleeve_length"
          :init-garment-left="initGarmentMeasures.sleevel"
          :init-garment-right="initGarmentMeasures.sleever"
          label="LONGUEUR MANCHE"
          class="longueur-manche"
          name="sleeve"
          @config="set"
        />
        <!-- shirt_m_05 -->
        <garment-config
          :smart="smartMeasures.back_shoulder"
          :smart-measurements="smartMeasurements.back_shoulder"
          :init-garment="initGarmentMeasures.shoulders"
          label="CARRURE DOS"
          class="carrure-dos"
          name="shoulders"
          @config="set"
        />
        <!-- shirt_m_11 -->
        <garment-config
          :smart="smartMeasures.biceps"
          :smart-measurements="smartMeasurements.biceps"
          :init-garment="initGarmentMeasures.biceps"
          label="1/2 BICEPS"
          class="demi-biceps"
          name="biceps"
          @config="set"
        />
        <!-- shirt_m_10 -->
        <garment-config
          :smart="smartMeasures.back_length"
          :smart-measurements="smartMeasurements.back_length"
          :init-garment="initGarmentMeasures.back"
          label="LONGUEUR DOS"
          class="longueur-dos"
          name="back"
          @config="set"
        />
        <!-- shirt_m_01 -->
        <garment-config
          :smart="smartMeasures.collar_real"
          :smart-measurements="smartMeasurements.collar_real"
          :init-garment="initGarmentMeasures.neck"
          label="TOUR DE COU"
          class="tour-de-cou"
          name="neck"
          @config="set"
        />
      </div>
    </div>
    <div class="shirt_alternations">
      <h4>Shirt Alternations</h4>
      <!-- shirt_alter_12 -->
      <div class="alt-flex row">
        <span class="fieldname">Sleeve Pleats</span>
        <div class="select">
          <select
            v-model="sleevePleats"
            class="ui dropdown selection"
            style="height: 40px"
            name="sleevePleats"
          >
            <option
              v-for="option in sleevePleatsOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value == '0' ? 'selected' : ''"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <!-- shirt_alter_1 -->
      <div class="alt-flex row">
        <span class="fieldname">Head position</span>
        <modifier
          :init-val="encolure"
          v-model="headPosition"
          class="modifier"
          left-text="Head forward"
          right-text="Straight back"
          column="headPosition"
          @modified="onMod"
        ></modifier>
      </div>
      <br />
      <!-- shirt_alter_2 shirt_alter_3 -->
      <div class="alt-flex row">
        <span class="fieldname">Shoulder position</span>
        <span class="ui checkbox">
          <input v-model="shoulderPositionLR" type="checkbox" />
          <label>L+R</label>
        </span>
        <modifier
          v-if="shoulderPositionLR"
          :init-val="pente_epaule_g"
          :slider-pops="[-0.5]"
          :slider-valid-min="-2"
          v-model="shoulderPositionLeft"
          left-text="Sloping"
          right-text="Square"
          column="shoulderPositionLeft"
          @modified="onMod"
        ></modifier>
        <div v-else class="modifier-lr">
          <modifier
            :init-val="pente_epaule_g"
            :slider-pops="[-0.5]"
            :slider-valid-min="-2"
            v-model="shoulderPositionLeft"
            class="modifier-top"
            main-label="L"
            left-text="Sloping"
            right-text="Square"
            column="shoulderPositionLeft"
            @modified="onMod"
          ></modifier>
          <modifier
            :init-val="pente_epaule_d"
            :slider-pops="[-0.5]"
            :slider-valid-min="-2"
            v-model="shoulderPositionRight"
            class="modifier-bottom"
            main-label="R"
            left-text="Sloping"
            right-text="Square"
            column="shoulderPositionRight"
            @modified="onMod"
          ></modifier>
        </div>
      </div>
      <br />
      <!-- shirt_alter_4 -->
      <div class="alt-flex row">
        <span class="fieldname">Low Shoulder Back Only</span>
        <span class="ui checkbox">
          <input v-model="penteDosLR" type="checkbox" disabled />
          <label>L+R</label>
        </span>
        <modifier
          v-if="penteDosLR"
          :slider-valid-min="-2"
          :slider-valid-max="0"
          :init-val="pente_dos"
          v-model="lowShoulderBackOnly"
          left-text="Sloping"
          column="lowShoulderBackOnly"
          @modified="onMod"
        ></modifier>
        <div v-else class="modifier-lr">
          <modifier
            :slider-valid-min="-2"
            :slider-valid-max="0"
            :init-val="pente_dos"
            v-model="lowShoulderBackOnly"
            class="modifier-top"
            main-label="L"
            left-text="Sloping"
            column="lowShoulderBackOnly"
            @modified="onMod"
          >
          </modifier>
          <modifier
            :slider-valid-min="-2"
            :slider-valid-max="0"
            :init-val="pente_dos"
            v-model="lowShoulderBackOnly"
            class="modifier-bottom"
            main-label="R"
            left-text="Sloping"
            column="lowShoulderBackOnly"
            @modified="onMod"
          >
          </modifier>
        </div>
      </div>
      <br />
      <!-- shirt_alter_5 -->
      <div class="alt-flex row">
        <span class="fieldname">Stooped</span>
        <modifier
          :slider-valid-min="0"
          :slider-valid-max="1.5"
          :init-val="stooped"
          v-model="alterStooped"
          column="alterStooped"
          @modified="onMod"
        ></modifier>
      </div>
      <br />
      <!-- shirt_alter_6 -->
      <div class="alt-flex row">
        <span class="fieldname">Armhole opening</span>
        <modifier
          :step="1"
          :slider-valid-min="-2"
          :slider-valid-max="2"
          :display-valid-min="-2"
          :display-valid-max="2"
          :init-val="position_emmanchure"
          v-model="armholeOpening"
          left-text="Smaller"
          right-text="Bigger"
          column="armholeOpening"
          @modified="onMod"
        >
        </modifier>
      </div>
      <br />
      <!-- shirt_alter_7 -->
      <div class="alt-flex row">
        <span class="fieldname">Front Yoke</span>
        <modifier
          :step="0.3"
          :slider-valid-min="-0.9"
          :slider-valid-max="0.9"
          :slider-display-min="-0.9"
          :slider-display-max="0.9"
          :init-val="front_yoke"
          v-model="frontYoke"
          left-text="Smaller"
          right-text="Bigger"
          column="frontYoke"
          @modified="onMod"
        >
        </modifier>
      </div>
      <br />
      <!-- shirt_alter_8 -->
      <div class="alt-flex row">
        <span class="fieldname">Front Chest</span>
        <modifier
          :slider-valid-min="-1"
          :slider-valid-max="1"
          :init-val="petite_poitrine"
          v-model="frontChest"
          column="frontChest"
          @modified="onMod"
        ></modifier>
      </div>
      <br />
      <!-- shirt_alter_9 -->
      <div class="alt-flex row">
        <span class="fieldname">Back Chest</span>
        <modifier
          :slider-valid-min="-1"
          :slider-valid-max="1"
          :init-val="petite_carrure"
          v-model="backChest"
          column="backChest"
          @modified="onMod"
        ></modifier>
      </div>
      <br />
      <!-- shirt_alter_10 -->
      <div class="alt-flex row">
        <span class="fieldname">Waist Allocation</span>
        <div>
          <span class="bold">Total waist:</span> {{ totalWaist }}--cm |
          <span class="bold">In front:</span> {{ frontWaist }}--cm |
          <span class="bold">In back:</span> {{ backWaist }}--cm
        </div>
        <div class="select">
          <select
            v-model="waistAllocation"
            class="ui dropdown selection"
            style="height: 40px"
            name="waistAllocation"
          >
            <option
              v-for="option in waistAllocationOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value == '0' ? 'selected' : ''"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <!-- shirt_alter_11 -->
      <div class="alt-flex row">
        <span class="fieldname">Hips Forward</span>
        <div style="margin-right: 50px">
          <modifier
            :step="1"
            :slider-valid-min="0"
            :slider-valid-max="5"
            :slider-display-min="0"
            :slider-display-max="5"
            :init-val="repart_bassin"
            v-model="hipsForward"
            column="hipsForward"
            @modified="onMod"
          ></modifier>
        </div>
      </div>
      <br />
      <!-- shirt_alter_12 -->
      <div class="alt-flex row">
        <span class="fieldname">Long front only</span>
        <div>
          <span class="bold">Longueur dos:</span> {{ backLength }}--cm |
          <span class="bold">Front length:</span> {{ frontLength }}--cm
        </div>
        <div class="select">
          <select
            v-model="longFrontOnly"
            class="ui dropdown selection"
            style="height: 40px"
            name="longFrontOnly"
          >
            <option
              v-for="option in longFrontOnlyOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value == '0' ? 'selected' : ''"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.shirt_measurements_header {
  margin-left: 10px;
}

.measures-container {
  width: 937px;
  height: 437px;
  position: relative;
  margin: 24px;
}

.demi-poitrine {
  width: 100px;
  position: absolute;
  top: 10px;
  left: 0;
  opacity: 0.7;
}

.demi-taille {
  width: 100px;
  position: absolute;
  top: 100px;
  left: 0;
  opacity: 0.7;
}

.demi-bassin {
  width: 100px;
  position: absolute;
  top: 200px;
  left: 0;
  opacity: 0.7;
}

.demi-poignets-boutonnes {
  width: 200px;
  position: absolute;
  top: 300px;
  left: 0;
  opacity: 0.7;
}

.longueur-manche {
  width: 200px;
  position: absolute;
  top: 0;
  left: 370px;
  opacity: 0.7;
}

.carrure-dos {
  width: 128px;
  position: absolute;
  top: 0;
  right: 10px;
  opacity: 0.7;
}

.demi-biceps {
  width: 128px;
  position: absolute;
  top: 100px;
  right: 10px;
  opacity: 0.7;
}

.longueur-dos {
  width: 128px;
  position: absolute;
  top: 200px;
  right: 10px;
  opacity: 0.7;
}

.tour-de-cou {
  width: 128px;
  position: absolute;
  top: 300px;
  right: 10px;
  opacity: 0.7;
}

.alt-flex {
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
}

.row {
  padding: 18px;
  border-style: solid;
  border-color: lightgray;
  border-width: 1px;
}

.fieldname {
  width: 200px;
  font-size: 18px;
}

/* .modifier {
  width: 500px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
} */

.checkbox {
  width: 50px;
}

.modifier-lr {
  position: relative;
  float: right;
  height: 140px;
  width: 500px;
}

.modifier-top,
.modifier-bottom {
  position: absolute;
}

.modifier-top {
  top: 0;
}

.modifier-bottom {
  bottom: 0;
}

.bold {
  font-weight: bold;
}

.select {
  height: 40px;
  width: 200px;
}
</style>
<script>
import Modifier from '../Modifier'

export default {
  name: 'ShirtEdit',
  components: {
    Modifier
  },
  props: {
    smartMeasures: {
      type: Object,
      default: () => ({})
    },
    initMeasures: {
      type: Object,
      default: null
    },
    encolure: {
      type: Number, // shirt_alter_1
      default: 0
    },
    pente_epaule_g: {
      type: Number, // shirt_alter_2
      default: 0
    },
    pente_epaule_d: {
      type: Number, // shirt_alter_3
      default: 0
    },
    pente_dos: {
      type: Number, // shirt_alter_4
      default: 0
    },
    stooped: {
      type: Number, // shirt_alter_5
      default: 0
    },
    position_emmanchure: {
      type: Number, // shirt_alter_6
      default: 0
    },
    front_yoke: {
      type: Number, // shirt_alter_7
      default: 0
    },
    petite_poitrine: {
      type: Number, // shirt_alter_8
      default: 0
    },
    petite_carrure: {
      type: Number, // shirt_alter_9
      default: 0
    },
    repart_taille: {
      type: Number, // shirt_alter_10
      default: 0
    },
    repart_bassin: {
      type: Number, // shirt_alter_11
      default: 0
    },
    longueur_avant: {
      type: Number, // shirt_alter_12
      default: 0
    },
    sleeve_pleats: {
      type: String, // shirt_alter_13
      default: 'S2P'
    },
    smartMeasurements: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      garmentMeasures: {},

      shoulderPositionLR: true,
      penteDosLR: true,

      headPosition: 0, // shirt_alter_1
      shoulderPositionLeft: 0, // shirt_alter_2
      shoulderPositionRight: 0, // shirt_alter_3
      lowShoulderBackOnly: 0, // shirt_alter_4
      alterStooped: 0, // shirt_alter_5
      armholeOpening: 0, // shirt_alter_6
      frontYoke: 0, // shirt_alter_7
      frontChest: 0, // shirt_alter_8
      backChest: 0, // shirt_alter_9
      waistAllocation: 0, // shirt_alter_10
      hipsForward: 0, // shirt_alter_11
      longFrontOnly: 0, // shirt_alter_12
      sleevePleats: 0, // shirt_alter_13

      key2name: {
        headPosition: 'encolure', // shirt_alter_1
        shoulderPositionLeft: 'pente_epaule_g', // shirt_alter_2
        shoulderPositionRight: 'pente_epaule_d', // shirt_alter_3
        lowShoulderBackOnly: 'pente_dos', // shirt_alter_4
        alterStooped: 'stooped', // shirt_alter_5
        armholeOpening: 'position_emmanchure', // shirt_alter_6
        frontYoke: 'front_yoke', // shirt_alter_7
        frontChest: 'petite_poitrine', // shirt_alter_8
        backChest: 'petite_carrure', // shirt_alter_9
        waistAllocation: 'repart_taille', // shirt_alter_10
        hipsForward: 'repart_bassin', // shirt_alter_11
        longFrontOnly: 'longueur_avant', // shirt_alter_12
        sleevePleats: 'sleeve_pleats' // shirt_alter_13
      },
      sleevePleatsOptions: [
        {
          value: 'S2P',
          label: '2 plis'
        },
        {
          value: 'S3P',
          label: '3 plis'
        }
      ]
    }
  },
  computed: {
    initGarmentMeasures() {
      const init = {}
      Object.keys(this.initMeasures).forEach((key) => {
        this.$set(init, key, parseFloat(this.initMeasures[key]))
      })
      return init
    },
    waistAllocationOptions() {
      return this.calcOptions(5, 0)
    },
    longFrontOnlyOptions() {
      return this.calcOptions(21, -10)
    },
    totalWaist() {
      return this.garmentMeasures && this.garmentMeasures.demi_taille
        ? this.garmentMeasures.demi_taille * 2
        : ''
    },
    frontWaist() {
      return this.garmentMeasures && this.garmentMeasures.demi_taille
        ? this.garmentMeasures.demi_taille + this.waistAllocation
        : ''
    },
    backWaist() {
      return this.garmentMeasures && this.garmentMeasures.demi_taille
        ? this.garmentMeasures.demi_taille - this.waistAllocation
        : ''
    },
    backLength() {
      return this.garmentMeasures && this.garmentMeasures.back
        ? this.garmentMeasures.back
        : ''
    },
    frontLength() {
      return this.garmentMeasures && this.garmentMeasures.back
        ? this.garmentMeasures.back + this.longFrontOnly
        : ''
    }
  },
  watch: {
    waistAllocation(val) {
      if (val === false) return
      this.$emit('set', { name: this.key2name.waistAllocation, measure: val })
    },
    longFrontOnly(val) {
      if (val === false) return
      this.$emit('set', { name: this.key2name.longFrontOnly, measure: val })
    },
    sleevePleats(val) {
      if (val === false) return
      this.$emit('set', { name: this.key2name.sleevePleats, measure: val })
    }
  },
  mounted() {
    this.headPosition = this.encolure // shirt_alter_1
    this.shoulderPositionLeft = this.pente_epaule_g // shirt_alter_2
    this.shoulderPositionRight = this.pente_epaule_d // shirt_alter_3
    this.lowShoulderBackOnly = this.pente_dos // shirt_alter_4
    this.alterStooped = this.stooped // shirt_alter_5
    this.armholeOpening = this.position_emmanchure // shirt_alter_6
    this.frontYoke = this.front_yoke // shirt_alter_7
    this.frontChest = this.petite_poitrine // shirt_alter_8
    this.backChest = this.petite_carrure // shirt_alter_9
    this.waistAllocation = this.repart_taille // shirt_alter_10
    this.hipsForward = this.repart_bassin // shirt_alter_11
    this.longFrontOnly = this.longueur_avant // shirt_alter_12
    this.sleevePleats = this.sleeve_pleats // shirt_alter_13
    this.shoulderPositionLR =
      this.shoulderPositionLeft === this.shoulderPositionRight
  },
  methods: {
    calcOptions(length, start) {
      const data = Array.from({ length }, (_, i) => start + i)
      const options = []
      if (data) {
        data.forEach((ele) => {
          options.push({
            value: ele,
            label: `${ele} cm`
          })
        })
      }
      return options
    },
    onMod(val) {
      if (val.key === 'shoulderPositionLeft' && this.shoulderPositionLR) {
        this.$emit('set', {
          name: this.key2name.shoulderPositionRight,
          measure: val.val
        })
      }
      this.$emit('set', { name: this.key2name[val.key], measure: val.val })
    },
    set(val) {
      this.$set(this.garmentMeasures, val.name, val.measure)
      this.$emit('set', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShirtEdit.vue?e8419ffa